export const DOCKCustomStyles = {
  root:{
    style:{
      position: 'fixed',
      zIndex: '500',
      width: '100%',
    }
  },
  listContainer:{
    style:{
      background:'rgba(35, 47, 69, 0.9)',
      borderColor:'rgba(35, 47, 69, 0.9)',
      padding:'8px',
      height:'80px',
      borderRadius:'1000px',
      width:'fit-content',
    }
  },
  list: {
    style:{
      gap:'8px'
    }
  },
  item:{
    style:{
      width:'20%',
      minWidth:'60px',
      height:'100%',
      padding:'0',
      borderRadius:'50%',
    }
  },
  itemLink:{
    style:{
      width:'100%',
      height:'64px',
    }
  }
}